import { useParams as useRouterParams } from "react-router-dom";

// Fix for `|undefined` in params

type Params<Key extends string = string> = {
  readonly [key in Key]: string;
};

function useParams<
  ParamsOrKey extends string | Record<string, string | undefined> = string
>(): Readonly<
  [ParamsOrKey] extends [string] ? Params<ParamsOrKey> : Partial<ParamsOrKey>
> {
  return useRouterParams() as any;
}

export default useParams;
